


























































import { Component, Prop, Vue } from "vue-property-decorator";
import { RegService } from "@common/service/base-service/reg";
import Vcode from "@common/components/puzzle-vcode";
import { RecruitService } from "@/zh-website/src/views/Recruit/service";
import { ICTLoginService } from "@common/ict/service/data-service/login";
@Component({
  components: { 
    Vcode 
  },
  mixins: []
})

export default class FillCommitment extends Vue {
  imgs = [
    require("@common/assets/slider-1.png"),
    require("@common/assets/slider-2.png"),
    require("@common/assets/slider-3.png"),
    require("@common/assets/slider-4.png")
  ];
  fgImg = "";
  fgY = 0;
  VCID = "";
  isShowSlider = false;
  isSliderSuccess = false;
  
  imgSrc = require('@/zh-website/src/assets/common/check.png');
  timer: any = null;
  isFinished = false;
  countDown = 0;
  commitmentForm = {
    phone: "",
    yzm: "",
    name: ""
  }

  contactRules = {
    name: [
        { required: true, message: "请输入您的姓名", trigger: "blur" },
        { min: 2, max: 50, message: "长度在 2 到 50 个字符", trigger: "blur" }
    ],

    yzm: [{ required: true, message: "请输入验证码", trigger: "blur" }],
    phone: [
        { required: true, message: "请输入手机号", trigger: "blur" },
        { pattern: RegService.PHONE, message: "手机号格式错误" }
    ]
  };

  get isFilled() {
    console.log("isFinished: " + this.isFinished);
    return this.isFinished;
  }

  //获取验证码
  getCode() {
    console.log("getCode");
    (this.$refs["commitmentForm"] as any).validateField("phone", err => {
      if (!err && !this.timer) {
        if (!this.isSliderSuccess) {
          this.getSlideInfo();
        } else {
          this.closeSliderLogin();
          //调用接口成功后倒计时
          RecruitService.getCode({ phone: this.commitmentForm.phone }).then(() => {
            this.countDown = 60;
            this.timer = setInterval(() => {
                this.countDown--;
                if (this.countDown <= 0) {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.countDown = 0;
                }
            }, 1000);
          });
        }
      }
    });
  }

  validateAndSubmit() {
    (this.$refs['commitmentForm'] as any).validate(valid => {
      if (valid) {
        this.submitForm();
      } else {
        return false;
      }
    });
  }

  submitForm() {
    console.log(this.commitmentForm);
    RecruitService.submitCommitment({
      name: this.commitmentForm.name,
      phone: this.commitmentForm.phone,
      code: this.commitmentForm.yzm
    }).then((res: any) => {
      this.commitmentForm = {
        name: "", //姓名
        yzm: "",
        phone: "",
      };
      this.isFinished = true;
    })
  }

  // 滑块验证失败
  failSliderLogin(err) {
    this.$message.warning("滑块验证失败");
    this.closeSliderLogin();
  }

  async checkVerifyCode({ x, y }) {
    return ICTLoginService.checkSliderRes({
      verificationCodeId: this.VCID,
      isDeleteAfterSuccess: true,
      x,
      y
    }).then((res: any) => {
      if (!res) {
        throw new Error();
      }
      return res;
    });
  }
  successSliderLogin(res) {
    if (res) {
      this.isSliderSuccess = true;
      this.getCode();
    }
  }
  getSlideInfo() {
    ICTLoginService.getVerifyCode().then(res => {
      if (res) {
        this.imgs = [res.shadeImage];
        this.fgImg = res.cutoutImage;
        this.fgY = res.y;
        this.VCID = res.verificationCodeId;
        // 显示登录右滑拼图验证
        this.isShowSlider = true;
      }
    });
  }

  closeSliderLogin() {
    this.isShowSlider = false;
    this.isSliderSuccess = false;
  }
}
